import type { ViewStyle } from 'react-native';

const BASE_TAB_BAR_HEIGHT = 60;

/**
 * Web implementation - preserves the original fixed tab bar height so the web
 * layout is unchanged. Web has no system bars to draw behind.
 */
export function useMobileTabBarInsetStyle(): ViewStyle {
  return {
    height: BASE_TAB_BAR_HEIGHT,
  };
}
